export default function ChatLogsIcon({ size = 24 }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_40679_35839'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' transform='matrix(-1 0 0 1 24 0)' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_40679_35839)'>
        <path
          d='M2.5 21.0385L6.0385 17.5H19.6923C20.1974 17.5 20.625 17.325 20.975 16.975C21.325 16.625 21.5 16.1974 21.5 15.6923V4.30775C21.5 3.80258 21.325 3.375 20.975 3.025C20.625 2.675 20.1974 2.5 19.6923 2.5H4.30775C3.80258 2.5 3.375 2.675 3.025 3.025C2.675 3.375 2.5 3.80258 2.5 4.30775V21.0385ZM19.6923 16H5.4L4 17.3848V4.30775C4 4.23075 4.03208 4.16025 4.09625 4.09625C4.16025 4.03208 4.23075 4 4.30775 4H19.6923C19.7693 4 19.8397 4.03208 19.9037 4.09625C19.9679 4.16025 20 4.23075 20 4.30775V15.6923C20 15.7692 19.9679 15.8398 19.9037 15.9038C19.8397 15.9679 19.7693 16 19.6923 16Z'
          fill='currentColor'
          strokeWidth={2}
        />
      </g>
    </svg>
  );
}
